/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const questionDataTypeSchema = z.enum(['select', 'text', 'open_text', 'file', 'datetime'])

export type QuestionDataTypeSchema = z.infer<typeof questionDataTypeSchema>
